import request from '@/utils/request'

// 查询工作日志模板列表
export function listWorkLogTemplates(data) {
  return request({
    url: '/crmWorkLogTemplate/list',
    method: 'post',
    data
  })
}

// 查询工作日志模板详情
export function getWorkLogTemplateDetail(id) {
  return request({
    url: `/crmWorkLogTemplate/detail/${id}`,
    method: 'get'
  })
}

// 保存工作日志模板
export function saveWorkLogTemplate(data) {
  return request({
    url: '/crmWorkLogTemplate/save',
    method: 'post',
    data
  })
}

// 删除工作日志模板
export function removeWorkLogTemplate(id) {
  return request({
    url: `/crmWorkLogTemplate/remove/${id}`,
    method: 'post'
  })
}

// 启停工作日志模板
export function changeWorkLogTemplateStatus(id, status) {
  return request({
    url: '/crmWorkLogTemplate/changeStatus',
    method: 'post',
    params: { id, status }
  })
}

// 当前员工可用工作日志模板
export function listWorkLogTemplateOptions() {
  return request({
    url: '/crmWorkLogTemplate/options',
    method: 'post'
  })
}

// 预览模板默认可见人
export function previewWorkLogTemplateViewers(templateId) {
  return request({
    url: `/crmWorkLogTemplate/viewerPreview/${templateId}`,
    method: 'get'
  })
}
